class SiteService {
    async getSiteDetails(qrCode) {
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/site/${qrCode}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            }
        });

        if(response.ok){
            return await response.json();
        } else if (response.status === 404){
            return {
                success: false
            }
        } else {
            throw(response.status);
        }
        
    }
}

export default SiteService;